export const selectReport = ({ IncidentReport_reducer }) => {
    return IncidentReport_reducer.report;
};
